export const INITIAL_STATE_RESPONSIBLE = {
  id: "",
  nome: "",
  cpf: "",
  creaCfta: "",
  endereco: "",
  bairro: "",
  numero: "",
  cidade: "",
  uf: "",
  cep: "",
  email: "",
  receita: "",
  profissao: "",
  telefone: "",
  celular: "",
  quantidadeReceita: "",
  art: "",
  observacao: "",
  tokenSC: "",
  complementoReceita: "",
  serieSC: "",
  conselho: "",
  contrato: "",
  ibge: "",
  status: "ativo",
  certUrl: null,
  passwordCert: null,
  dataVencimentoCert: null,
}

export const INVALID_FIELDS_RESPONSIBLE = {
  nome: "",
  cpf: "",
  cep: "",
  endereco: "",
  bairro: "",
  numero: "",
  cidade: "",
  uf: "",
  quantidadeReceita: "",
  receita: "",
  art: "",
}
